module.exports = "https://trybtryb-legacy.web.app/img/analytics.6a78172e.webp";